/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ShowManagementDeleteShowResponse } from './ShowManagementDeleteShowResponse';

export type ShowManagementDeleteShowResponseApiRespoonse = {
    data?: ShowManagementDeleteShowResponse;
    status?: ShowManagementDeleteShowResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ShowManagementDeleteShowResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

